// extracted by mini-css-extract-plugin
export default {"iconColor":"#071948","disabledIconColor":"#b5bac8","link":"style--link--04ce1e","enabled":"style--enabled--f96984","disabled":"style--disabled--6e43b8"};